export enum SocialNetwork {
	Facebook,
	Twitter,
	Mobile,
}

export enum ShareType {
	General = "general",
	League = "league",
}

export enum RequestState {
	IDLE,
	Requested,
	Received,
}

export enum PrivacyType {
	Private = "private",
	Public = "public",
}

export enum SortOrder {
	ASC = "asc",
	DESC = "desc",
}

export enum EventStatus {
	Scheduled = "scheduled",
	Active = "playing",
	Complete = "complete",
	Cancelled = "cancelled",
}

export enum RoundStatus {
	Scheduled = "scheduled",
	Active = "playing",
	Complete = "completed",
}

export enum LeagueStatus {
	Scheduled = "scheduled",
	Active = "playing",
	Complete = "complete",
	Cancelled = "cancelled",
}

export enum LeaguePrivacy {
	Public = "public",
	Private = "private",
}

export enum LeagueType {
	Overall = "overall",
	Regular = "regular",
}

export enum LeagueFilterTypeBackend {
	SEASON = "season",
	SEPTEMBER_CHALLENGE = "september_challenge",
	MONTHS = "months",
	TOURNAMENT = "tournament",
	ROLEX_SERIES = "rolex_series",
	GLOBAL_SWINGS = "global_swings",
	THE_MAJORS = "the_majors",
}

export enum FantasyTileStatus {
	SCHEDULED = "scheduled",
	ACTIVE = "active",
	COMPLETE = "completed",
}

export enum FantasyTileType {
	FULL_FANTASY = "full_fantasy",
	SWING = "swing",
	MAJOR = "major",
}

export enum BoosterType {
	TRIPLE_CAPTAIN = "triple_captain",
	BENCH_BOOST = "bench_boost",
}

export enum BoosterActionType {
	APPLY = "apply",
	REMOVE = "remove",
	USED = "used",
}
